import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, StatusChangeEvent, TouchedChangeEvent } from '@angular/forms';
import { Observable, startWith } from 'rxjs';
import { filter, map } from 'rxjs/operators';

/**
 * When marking a `FormGroup` as touched, use {@link markAllAsTouchedAndUpdateRecursively} to also emit the status change for
 * all nested `FormControl`s.
 */
@Pipe({ name: 'invalidAsync', standalone: true })
export class InvalidAsyncPipe implements PipeTransform {
  transform(control: AbstractControl): Observable<boolean> {
    return control.events.pipe(
      filter((event) => event instanceof StatusChangeEvent || event instanceof TouchedChangeEvent),
      startWith(null),
      map(() => control?.invalid && control?.touched && control?.enabled)
    );
  }
}
